export const joinAddress = (addressParams: (string | null)[]) =>
  addressParams
    .reduce((acc: string[], param: string | null) => {
      if (param) {
        acc.push(param)
      }
      return acc
    }, [])
    .join(", ")

export interface PageTagsType {
  [k: string]: string
}

export const tagExists = (
  pageTags: PageTagsType,
  ...tags: string[]
): boolean => {
  for (const tag of Object.keys(pageTags)) {
    if (tags.includes(tag)) {
      return true
    }
  }
  return false
}
